import { render } from "./TableSkeletonV2.vue?vue&type=template&id=be865b0e"
import script from "./TableSkeletonV2.vue?vue&type=script&lang=js"
export * from "./TableSkeletonV2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__